import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complaint-reg-sanction-grid',
  templateUrl: './complaint-reg-sanction-grid.component.html',
  styleUrls: ['./complaint-reg-sanction-grid.component.css']
})
export class ComplaintRegSanctionGridComponent implements OnInit {
  title="Complaint Registration Sanction";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/depart-enquiry/complaint-reg-sanction/complaint-reg-sanction-grid/complaint-reg-sanction-grid.component.ts